module.exports = __webpack_public_path__ + "static/media/ned_logo.69d57cc5.png";